<template>
  <DownloadModelsTable
    title="Download Hit Generation Models"
    category-filter="Hit Generation"
  />
</template>

<script>
import DownloadModelsTable from '@/components/DownloadModelsTable.vue';

export default {
  name: 'HitGenerationDownloadView',
  components: {
    DownloadModelsTable
  },
  mounted() {
    this.checkLoggedIn(this.$session);
  }
};
</script>
